var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 10.225H13.4286V7.13125C13.4286 3.53047 10.9929 0.6 8 0.6C5.00714 0.6 2.57143 3.53047 2.57143 7.13125V10.225H1.71429C0.767857 10.225 0 11.1488 0 12.2875V20.5375C0 21.6762 0.767857 22.6 1.71429 22.6H14.2857C15.2321 22.6 16 21.6762 16 20.5375V12.2875C16 11.1488 15.2321 10.225 14.2857 10.225ZM10.5714 10.225H5.42857V7.13125C5.42857 5.42539 6.58214 4.0375 8 4.0375C9.41786 4.0375 10.5714 5.42539 10.5714 7.13125V10.225Z",
    fill: "#417689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.4b284fe43ceb623907b6b483cc3cb4c8.svg";
export { ForwardRef as ReactComponent };